<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.58059 5.58059C8.02137 3.1398 11.9786 3.1398 14.4194 5.58059C16.8602 8.02137 16.8602 11.9786 14.4194 14.4194C11.9786 16.8602 8.02137 16.8602 5.58059 14.4194C3.1398 11.9786 3.1398 8.02137 5.58059 5.58059Z" />
</template>
